<template>
  <pbc-overlay ref='modal' @close="$emit('close')" :disable-title="true">
    <template #default="{}">
      <input class="rounded-lg overflow-hidden appearance-none bg-gray-400 h-3 w-64" 
             type="range"
             min="1"
             max="15"
             step="1"
             value="15"
             v-model='timestep' />
    </template>
  </pbc-overlay>

</template>
<script>
export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timestep: 10
    }
  }
}
</script>
